module.exports = __webpack_public_path__ + "img/icon_mudidi_home.d11c2e2e.png";